import { extraDictionaries } from "@/i18n-extra";
import fr from "@/i18n-fr";

export const LANGS = [
  { code: "es", label: "ES", name: "Español" },
  { code: "en", label: "EN", name: "English" },
  { code: "pt", label: "PT", name: "Português" },
  { code: "ru", label: "RU", name: "Русский" },
  { code: "ar", label: "AR", name: "العربية" },
  { code: "zh", label: "中文", name: "中文" },
  { code: "ja", label: "JA", name: "日本語" },
];

export const IMAGES = {
  hero_aquaculture: "https://images.unsplash.com/photo-1544250035-a2dae20b4d73?crop=entropy&cs=srgb&fm=jpg&q=85",
  shrimp_larvae_inspection: "https://images.unsplash.com/photo-1748261347768-a32434751a9a?crop=entropy&cs=srgb&fm=jpg&q=85",
  shrimp_culture_sample: "https://images.unsplash.com/photo-1582719298818-904ce0e5cd87?crop=entropy&cs=srgb&fm=jpg&q=85",
  microalgae_pond_aerial: "https://images.unsplash.com/photo-1568279668196-697fbf5249ca?crop=entropy&cs=srgb&fm=jpg&q=85",
  coastal_buoy_sensors: "https://images.unsplash.com/photo-1603130114455-ef5a2fba64d9?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const es = {
  nav: {
    home: "Inicio", how: "Cómo Funciona", licensing: "Licenciamiento", impact: "Impacto y CO₂",
    contact: "Contacto", cta: "Solicitar Licencia", pseq2: "PSEQ2", menu: "Menú", close: "Cerrar", logout: "Salir", oracle: "Oráculo",
  },
  admin: {
    title: "Panel de administración",
    licenses: "Solicitudes de licencia",
    contacts: "Mensajes de contacto",
    empty: "Nada por aquí todavía.",
    forbidden: "Acceso reservado al equipo Dekrbat Pure.",
    statusT: "Estado",
    pending: "En espera",
    accepted: "Aceptada",
    rejected: "Rechazada",
    accept: "Aceptar",
    reject: "Rechazar",
    loginFirst: "Inicia sesión con una cuenta de administrador.",
    filterAll: "Todas",
    reply: "Responder",
    date: "Fecha",
  },
  oracle: {
    overline: "Oráculo offline",
    title: "Oráculo Dekrbat — predicción y constatación en tiempo real",
    sub: "Instala la app: el clima de cada zona se descarga en segundo plano. Gráficos, constataciones e informes PDF funcionan sin conexión.",
    install: "Instalar la app",
    installing: "Usa el menú del navegador para instalar",
    online: "En línea",
    offline: "Sin conexión — datos en caché",
    syncing: "Sincronizando zonas",
    syncNow: "Sincronizar",
    lastSync: "Última sincronización",
    never: "nunca",
    defaultZone: "Zona camaronera",
    scenarioZone: "Tu escenario",
    constatTitle: "Constatación en directo",
    cachedAt: "Datos del",
    verdicts: { validated: "Validado", partial: "Parcial", rejected: "Rechazado" },
    criteria: { temp: "Temperatura", sunshine: "Sol", humidity: "Humedad", pressure: "Presión", co2: "CO₂" },
    predTitle: "Predicción a 7 días",
    weeklyPts: "PSEQ2 est. por estanque / semana",
    chartTemp: "Temp máx",
    chartSun: "Sol",
    reportBtn: "Informe PDF de zona",
    noData: "Aún sin datos de esta zona — sincroniza en línea.",
    customZone: "Mi zona",
    addZoneTitle: "Añade tu zona",
    addZoneHint: "Haz clic en el mapa para colocar el marcador, nombra tu zona y guárdala.",
    zoneNamePh: "Nombre de la zona",
    saveZone: "Guardar",
    loginToAdd: "Inicia sesión para guardar tus propias zonas, conectar tus sondas y recibir alertas por correo.",
    zoneSaved: "Zona guardada",
    zoneDeleted: "Zona eliminada",
    saveFailed: "Error al guardar",
    deleteZone: "Eliminar",
    alertsOn: "Alertas por correo activadas",
    alertsOff: "Alertas por correo desactivadas",
    sensorConnect: "Conectar una sonda",
    sensorKeyOnce: "Clave API — cópiala ahora, no se mostrará de nuevo.",
    sensorLive: "Sonda real",
    sensorOffline: "Sonda sin conexión",
    sensorCurl: "Ejemplo de envío desde tu gateway",
    thresholdsTitle: "Umbrales personalizados",
    idealRange: "rango ideal",
    sunMin: "mín (h)",
    thresholdsSaved: "Umbrales guardados",
    sensorHistory: "Historial de sonda",
    noSensorData: "Sin lecturas de sonda por ahora.",
    fieldMode: "Modo campo",
    freshToday: "Datos de hoy",
    freshCache: "Caché del",
    tour: {
      replay: "Tutorial",
      next: "Siguiente",
      skip: "Omitir",
      done: "Terminar",
      steps: [
        { t: "Bienvenido al Oracle", b: "60 segundos para dominar la vigilancia de tus estanques. ¡Vamos!" },
        { t: "Estado de conexión", b: "Verde = en línea, ámbar = sin conexión con datos en caché. El Oracle funciona incluso sin red." },
        { t: "Sincronización", b: "Un clic descarga el clima de los próximos 7 días para todas tus zonas." },
        { t: "Modo campo", b: "Botones grandes y contraste reforzado: legible a pleno sol junto a los estanques." },
        { t: "Tu propia zona", b: "Haz clic en el mapa y nombra tu zona: será vigilada como las demás (requiere iniciar sesión)." },
        { t: "El veredicto de un vistazo", b: "Validado, Parcial o Rechazado: el parte meteorológico del día, con tus sondas reales si están conectadas." },
        { t: "Instala la app", b: "Añade el Oracle a tu teléfono: se abre como una aplicación, incluso sin red." },
        { t: "¡Eso es todo!", b: "Repite este tutorial cuando quieras con el botón Tutorial de arriba." },
      ],
    },
  },
  landing: {
    overline: "Dossier desclasificado",
    title: "Alimento vivo local para el camarón juvenil de tu región.",
    sub: "Un sistema completo de producción de microalgas que conecta productores artesanales con larvicultores de camarón: cadena corta, cero dependencia de importaciones, empleo que se queda en la región.",
    points: ["Producción artesanal de microalgas vivas", "Cadena corta productor → larvicultor", "Ingresos que se quedan en tu región"],
    visitor: "Entrar como visitante",
    google: "Continuar con Google",
    divider: "o con tu correo",
    name: "Nombre",
    email: "Correo",
    password: "Contraseña",
    loginBtn: "Entrar",
    signupBtn: "Crear cuenta",
    toSignup: "¿Sin cuenta? Crear una",
    toLogin: "¿Ya tienes cuenta? Entrar",
    err: "Credenciales inválidas o correo ya registrado",
  },
  hero: {
    overline: "Origen El Salvador · alcance global",
    lines: ["Alimento vivo local", "para el camarón juvenil", "de tu región."],
    sub: "Dekrbat Pure licencia un sistema completo de producción de microalgas que conecta a productores artesanales con larvicultores de camarón — una cadena de suministro corta que reduce la dependencia de insumos importados y convierte el CO₂ en puntos de carbono verificados por sensores.",
    ctaPrimary: "Solicitar Licencia",
    ctaSecondary: "Ver cómo funciona",
    imageCaption: "Estanques de cultivo de microalgas",
    telemetryLabel: "Oráculo de decarbonización",
    telemetryLive: "señal en vivo",
    telemetryNote: "Transmisión conceptual simulada",
    telemetryLines: [
      "sensor A-03 · CO₂ disuelto · lectura verificada",
      "oráculo · validación de absorción natural",
      "punto de carbono emitido · lote #0182",
      "sensor B-11 · calidad de agua · parámetros estables",
      "oráculo · telemetría sincronizada por estanque",
      "punto de carbono emitido · lote #0183",
    ],
  },
  valprop: {
    overline: "La propuesta",
    title: "Una cadena corta reemplaza a una cadena importada",
    imported: {
      title: "Insumo importado",
      points: [
        "Viaja miles de kilómetros hasta la larvicultura",
        "Costos expuestos a divisas y logística internacional",
        "Trazabilidad limitada del origen biológico",
        "Valor económico que sale de la región",
      ],
    },
    local: {
      title: "Red local Dekrbat Pure",
      points: [
        "Cultivo en estanques de microalgas dentro de la región",
        "Entrega directa del productor artesanal al larvicultor",
        "Telemetría de sensores en cada estanque",
        "Empleo sostenible y valor que permanece en tu región",
      ],
    },
  },
  bento: {
    overline: "El sistema",
    title: "Cuatro piezas, un solo ecosistema",
    items: {
      ponds: { title: "Estanques de cultivo", desc: "Infraestructura de producción de microalgas pensada para condiciones costeras y rurales." },
      coops: { title: "Red de cooperativas", desc: "Productores artesanales organizados abastecen directamente a los laboratorios de larvas de su región." },
      sensors: { title: "Sensores en línea", desc: "Monitoreo continuo de calidad de agua y CO₂ disuelto en cada estanque de cultivo." },
      oracle: { title: "Oráculo de carbono", desc: "La telemetría validada se convierte en puntos de carbono en tiempo real, trazables por lote." },
    },
  },
  marquee: [
    "Soberanía alimentaria", "Cero dependencia de importaciones", "Trazabilidad por sensores",
    "Empleo local sostenible", "Puntos de carbono en tiempo real", "Cadena de suministro corta",
  ],
  calc: {
    overline: "Modelo conceptual",
    title: "Dimensiona tu red de estanques",
    desc: "Explora cómo escala la telemetría del sistema según la superficie de cultivo.",
    sliderLabel: "Hectáreas de estanques de cultivo",
    unit: "ha",
    outputs: { volume: "Índice de producción relativo", datapoints: "Lecturas de sensores por día", points: "Puntos de carbono emitidos por día" },
    disclaimer: "Cifras simuladas con fines ilustrativos. No representan datos de rendimiento reales.",
  },
    xr: {
      overline: "Modo espacial",
      title: "Tu granja en holograma, a tu alrededor",
      sub: "Gafas XREAL, Beam Pro o una simple pantalla: el simulador PSEQ2 se convierte en una maqueta 3D espacial — globo satelital, estanques en volumen, clima real.",
    },
  ctaSection: {
    title: "¿Listo para cultivar el futuro del camarón?",
    desc: "Únete a la primera red de microalgas con licencia para la larvicultura.",
    btn: "Solicitar Licencia",
  },
  how: {
    hero: {
      overline: "Cómo funciona",
      title: "Del estanque a la larva, sin intermediarios",
      sub: "Un ecosistema de cuatro pasos que convierte agua, luz y CO₂ en alimento vivo local — medido en cada etapa.",
    },
    steps: [
      { k: "Paso 01", title: "Construcción e inoculación", desc: "Cada sitio licenciado instala sus estanques de cultivo y recibe las cepas iniciales junto con el protocolo de producción Dekrbat Pure." },
      { k: "Paso 02", title: "Crecimiento monitoreado por sensores", desc: "Sondas ópticas y de CO₂ disuelto registran la calidad del agua y la actividad biológica en tiempo real, estanque por estanque." },
      { k: "Paso 03", title: "Distribución local directa", desc: "La cosecha viaja del productor artesanal al larvicultor de la misma región — una cadena corta, sin importaciones." },
      { k: "Paso 04", title: "Validación del oráculo", desc: "El oráculo de decarbonización valida la absorción natural de CO₂ medida por sensores y emite puntos de carbono trazables." },
    ],
    sensor: {
      overline: "Tecnología",
      title: "Telemetría que nunca duerme",
      desc: "Cada estanque licenciado incorpora un kit de sensores que transmite lecturas continuas al oráculo de decarbonización.",
      points: ["Sondas ópticas de calidad de agua", "Sensores de CO₂ disuelto", "Transmisión de datos en tiempo real", "Trazabilidad por estanque y por lote"],
    },
    galleryCaptions: ["Inspección de larvas de camarón", "Muestra de cultivo en laboratorio"],
  },
  licensing: {
    hero: {
      overline: "Licenciamiento",
      title: "Una licencia para cada escala de producción",
      sub: "Dekrbat Pure licencia su sistema completo de producción de microalgas a cooperativas y sitios en cualquier región del mundo.",
    },
    coop: {
      badge: "Cooperativas",
      title: "Licencia por Cooperativa",
      desc: "Modelo regional para cooperativas y asociaciones de productores que operan múltiples fincas o laboratorios de larvas.",
      features: [
        "Cobertura multi-finca bajo una sola licencia",
        "Kits de sensores asignados por estanque",
        "Protocolos de producción y formación del equipo",
        "Acceso de la cooperativa al panel de telemetría del oráculo",
        "Conexión con larvicultores de la región",
      ],
    },
    site: {
      badge: "Sitios individuales",
      title: "Licencia por Sitio",
      desc: "Despliegue a medida para una sola instalación: laboratorio de larvas, finca o estanque piloto.",
      features: [
        "Licencia dedicada a una instalación",
        "Kit de sensores dimensionado para el sitio",
        "Puesta en marcha asistida e inoculación inicial",
        "Telemetría y puntos de carbono del propio sitio",
        "Ruta de crecimiento hacia el modelo cooperativo",
      ],
    },
    selectBtn: "Solicitar esta licencia",
    form: {
      title: "Solicitud de licencia",
      desc: "Cuéntanos sobre tu operación y el equipo de Dekrbat Pure evaluará tu solicitud.",
      name: "Nombre completo", org: "Cooperativa o empresa", email: "Correo electrónico", phone: "Teléfono",
      department: "País / Región", type: "Tipo de licencia", typeCoop: "Por cooperativa", typeSite: "Por sitio",
      ponds: "Número de estanques o hectáreas", message: "Mensaje (opcional)",
      submit: "Enviar solicitud", sending: "Enviando…",
      success: "Solicitud recibida. El equipo de Dekrbat Pure la revisará pronto.",
      error: "No se pudo enviar. Inténtalo de nuevo.",
      selectPlaceholder: "Selecciona una opción",
    },
  },
  impact: {
    hero: {
      overline: "Impacto y CO₂",
      title: "Cada estanque mide lo que absorbe",
      sub: "Las microalgas capturan CO₂ de forma natural al crecer. Dekrbat Pure mide esa absorción con sensores y la valida con su oráculo de decarbonización, generando puntos de carbono en tiempo real.",
    },
    oracle: {
      overline: "El oráculo",
      title: "De la señal del sensor al punto de carbono",
      desc: "La arquitectura de medición de Dekrbat Pure convierte telemetría biológica en un registro verificable, sin depender de declaraciones externas.",
      flow: ["Estanques de microalgas", "Sensores de CO₂", "Oráculo de decarbonización", "Puntos de carbono"],
      flowDescs: [
        "Absorción natural de CO₂ durante el crecimiento",
        "Lecturas continuas de CO₂ disuelto",
        "Validación de la telemetría en tiempo real",
        "Registro trazable por estanque y por lote",
      ],
    },
    telemetry: { title: "Telemetría en vivo", note: "Simulación conceptual del flujo de datos" },
    reel: {
      overline: "Historia del carbono",
      title: "Del estanque al punto de carbono, en movimiento",
      slides: [
        { k: "01 · Estanques", title: "Cultivo vivo", desc: "Los estanques de microalgas capturan CO₂ de forma natural mientras producen alimento vivo para la larvicultura." },
        { k: "02 · Sensores", title: "Medición continua", desc: "Sondas de CO₂ disuelto y de calidad de agua registran cada estanque en tiempo real." },
        { k: "03 · Oráculo", title: "Validación", desc: "El oráculo de decarbonización valida la telemetría y la convierte en un registro verificable." },
        { k: "04 · Puntos", title: "Puntos de carbono", desc: "Cada validación emite puntos de carbono trazables por estanque y por lote." },
      ],
    },
    chain: {
      overline: "Cadena de valor",
      title: "Impacto en cuatro dimensiones",
      items: [
        { title: "Ambiental", desc: "Extracción natural de CO₂ medida por sensores y validada por el oráculo, lote por lote." },
        { title: "Social", desc: "Empleo sostenible a largo plazo para productores artesanales y cooperativas locales." },
        { title: "Económico", desc: "Resiliencia para los larvicultores al reducir la exposición a insumos importados." },
        { title: "Seguridad de suministro", desc: "Una nueva cadena de valor local centrada en los estanques de cultivo de microalgas." },
      ],
    },
  },
  contact: {
    hero: {
      overline: "Contacto",
      title: "Hablemos de tu proyecto",
      sub: "Escríbenos y el equipo de Dekrbat Pure te responderá. También puedes consultar las solicitudes guardadas en el sistema.",
    },
    form: {
      name: "Nombre completo", email: "Correo electrónico", subject: "Asunto", message: "Mensaje",
      submit: "Enviar mensaje", sending: "Enviando…",
      success: "Mensaje enviado y guardado.", error: "No se pudo enviar. Inténtalo de nuevo.",
    },
    drawer: {
      btn: "Ver solicitudes guardadas", title: "Solicitudes guardadas", empty: "Aún no hay solicitudes registradas.",
      licenseTag: "Licencia", contactTag: "Contacto", close: "Cerrar", loading: "Cargando…",
    },
  },
  intro: {
    dossier: "Expediente · Global", skip: "Clic para omitir",
    soundOn: "Sonido activado — clic para silenciar", soundOff: "Sonido silenciado",
  },
  story: {
    overline: "La historia",
    title: "Una economía solidaria que nace del agua",
    scenes: [
      { k: "Escena 01", title: "El valor que se va", desc: "Durante años, el alimento para la larvicultura llegó importado: cada compra enviaba recursos fuera de la región." },
      { k: "Escena 02", title: "El productor cultiva", desc: "Productores artesanales levantan estanques de microalgas: agua, sol y CO₂ se convierten en alimento vivo." },
      { k: "Escena 03", title: "La cooperativa conecta", desc: "La cosecha viaja directa al larvicultor de la región. Sin intermediarios, sin importaciones: una cadena corta." },
      { k: "Escena 04", title: "El valor se queda", desc: "Empleo local sostenible, ingresos para la cooperativa y puntos de carbono verificados por sensores: la economía crece en casa." },
    ],
  },
  pseq2: {
    overline: "Visualización pre-implantación",
    title: "PSEQ2 — Punto de Secuestración de 2ª generación",
    sub: "Antes de instalar tus estanques de microalgas, visualiza el potencial de decarbonización de cualquier punto del planeta: el clima local real alimenta la simulación y cada resultado aparece en un cubo holográfico.",
    config: {
      title: "Configura tu proyecto",
      bassins: "Número de estanques",
      bassinsFree: "O escribe el número exacto",
      surfaceFixed: "Superficie por estanque: 100 m² — dividido en 4 unidades independientes de 25 m² para limitar la contaminación cruzada",
      totalSurface: "Superficie total",
      sun: "Cobertura del sitio",
      sunFull: "Abierta", sunMid: "Mixta", sunLow: "Sombreada",
      searchPlaceholder: "Buscar ciudad o lugar…",
      share: "Compartir simulación",
      shareCopied: "Enlace copiado al portapapeles",
    },
    location: {
      title: "Ubicación del proyecto",
      hint: "Haz clic en el mapa o busca un lugar",
      loading: "Cargando clima local…",
      error: "Clima no disponible en este punto",
      none: "Elige un punto en el mapa",
      satellite: "Satélite",
      mapLabel: "Mapa",
      locate: "Mi ubicación",
    },
    tour: {
      replay: "Tutorial",
      next: "Siguiente",
      skip: "Omitir",
      done: "Terminar",
      steps: [
        { t: "Bienvenido al simulador PSEQ2", b: "Un minuto para estimar tu producción local de alimento vivo. ¡Vamos!" },
        { t: "Número de estanques", b: "Arrastra el control: cada estanque es una unidad independiente de 100 m² que limita la contaminación cruzada." },
        { t: "Régimen solar", b: "Cielo abierto, mixto o sombreado: la luz impulsa el crecimiento de las microalgas." },
        { t: "Ubicación del proyecto", b: "Haz clic en el mapa o usa Mi ubicación: el simulador carga el clima real del lugar." },
        { t: "El cubo holográfico", b: "Tus resultados en 3D: puntos PSEQ2, CO₂ capturado, alimento local y empleos. Gíralo con el dedo." },
        { t: "Informe PDF", b: "Exporta un informe completo de tu escenario, listo para compartir con tu cooperativa." },
        { t: "Compartir la simulación", b: "Un clic copia un enlace con tarjeta satelital de vista previa para WhatsApp y redes sociales." },
        { t: "¡Listo!", b: "Repite este tutorial cuando quieras con el botón Tutorial." },
      ],
    },
    weather: { temp: "Temperatura", humidity: "Humedad", pressure: "Presión", sunshine: "Sol al día", hours: "h" },
    rating: {
      title: "Veredicto de implantación",
      basis: "Calculado con el clima local real: temperatura, sol, humedad y presión",
      levels: ["No recomendado", "Pasable", "Correcto", "Bueno", "Super"],
    },
    cubes: {
      pseq2: { label: "PSEQ2 potenciales", unit: "pts / año" },
      co2: { label: "CO₂ secuestrado", unit: "t / año" },
      feed: { label: "Alimento vivo local", unit: "índice" },
      jobs: { label: "Empleos locales", unit: "puestos" },
    },
    preview: {
      title: "Vista previa del informe",
      config: "Configuración",
      weather: "Clima local",
      capacity: "Resumen de capacidad",
      contaminationTitle: "Contención de la contaminación",
      contaminationText: "Cada estanque de 100 m² se divide en 4 unidades independientes de 25 m²: si aparece un foco, solo esa unidad se aísla y entra en cuarentena — el resto de la producción continúa.",
    },
    history: {
      title: "Historial de escenarios",
      save: "Guardar escenario",
      saved: "Escenario guardado",
      error: "No se pudo guardar el escenario",
      empty: "Aún no hay escenarios guardados: configura y guarda tu primera simulación.",
      exportPdf: "Exportar PDF",
      publish: "Publicar",
      unpublish: "Retirar",
      sharedTag: "Público",
      tabAll: "Todos",
      tabPublic: "Públicos",
      date: "Fecha",
    },
    disclaimer: "Modelo conceptual de previsualización: valores simulados a partir del clima local real, no constituyen una medición ni un compromiso de rendimiento.",
    what: {
      overline: "Definición",
      title: "¿Qué es un PSEQ2?",
      desc: "El PSEQ2 — Punto de Secuestración de segunda generación — es la unidad que emite el oráculo de decarbonización de Dekrbat Pure cuando la telemetría de los sensores valida una captura natural de CO₂ por las microalgas.",
      cards: [
        { title: "Medido", desc: "Sondas de CO₂ disuelto y calidad de agua en continuo, en cada estanque." },
        { title: "Validado", desc: "El oráculo verifica la telemetría en tiempo real, estanque por estanque, lote por lote." },
        { title: "Emitido", desc: "Cada validación genera un PSEQ2 trazable, visible en tus cubos holográficos." },
      ],
    },
    cta: {
      title: "Pasa de la simulación al estanque real",
      desc: "Solicita tu licencia y convierte estos cubos holográficos en telemetría real.",
      btn: "Solicitar Licencia",
    },
    teaser: {
      overline: "Nuevo",
      title: "Visualiza antes de instalar",
      desc: "El simulador PSEQ2 proyecta el potencial de decarbonización de tus futuros estanques en cubos holográficos 3D, con el clima local real.",
      btn: "Abrir el simulador",
    },
    report: {
      btn: "Descargar informe PDF",
      title: "Informe de simulacion PSEQ2",
      config: "Configuracion",
      capacity: "Resumen de capacidad",
      weatherT: "Clima local",
      ratingT: "Veredicto",
      bassins: "Numero de estanques",
      surfaceFixed: "Superficie por estanque: 100 m2 (4 unidades independientes de 25 m2, riesgo de contaminacion cruzada limitado)",
      totalSurface: "Superficie total (m2)",
      contaminationTitle: "Contencion de la contaminacion",
      contaminationText: "Cada estanque de 100 m2 se divide en 4 unidades independientes de 25 m2: si aparece un foco, unicamente esa unidad queda aislada y en cuarentena; el resto de la produccion continua.",
      sun: "Cobertura del sitio",
      locationT: "Ubicacion",
      date: "Generado el",
      footer: "Dekrbat Pure · Modelo conceptual de previsualizacion — valores simulados, sin compromiso de rendimiento.",
    },
  },
  footer: {
    tagline: "Sistemas locales de cultivo de microalgas para la larvicultura de camarón, de El Salvador para el mundo.",
    nav: "Navegación",
    location: "El Salvador, Centroamérica",
    rights: "Todos los derechos reservados.",
  },
};

const en = {
  nav: {
    home: "Home", how: "How It Works", licensing: "Licensing", impact: "Impact & CO₂",
    contact: "Contact", cta: "Request License", pseq2: "PSEQ2", menu: "Menu", close: "Close", logout: "Log out", oracle: "Oracle",
  },
  admin: {
    title: "Admin panel",
    licenses: "License requests",
    contacts: "Contact messages",
    empty: "Nothing here yet.",
    forbidden: "Access restricted to the Dekrbat Pure team.",
    statusT: "Status",
    pending: "Pending",
    accepted: "Accepted",
    rejected: "Rejected",
    accept: "Accept",
    reject: "Reject",
    loginFirst: "Log in with an admin account.",
    filterAll: "All",
    reply: "Reply",
    date: "Date",
  },
  oracle: {
    overline: "Offline oracle",
    title: "Dekrbat Oracle — prediction and real-time constat",
    sub: "Install the app: every zone's weather downloads in the background. Graphs, constats and PDF reports keep working offline.",
    install: "Install the app",
    installing: "Use your browser menu to install",
    online: "Online",
    offline: "Offline — cached data",
    syncing: "Syncing zones",
    syncNow: "Sync now",
    lastSync: "Last sync",
    never: "never",
    defaultZone: "Shrimp zone",
    scenarioZone: "Your scenario",
    constatTitle: "Live constat",
    cachedAt: "Data from",
    verdicts: { validated: "Validated", partial: "Partial", rejected: "Rejected" },
    criteria: { temp: "Temperature", sunshine: "Sunshine", humidity: "Humidity", pressure: "Pressure", co2: "CO₂" },
    predTitle: "7-day prediction",
    weeklyPts: "est. PSEQ2 per pond / week",
    chartTemp: "Max temp",
    chartSun: "Sunshine",
    reportBtn: "Zone PDF report",
    noData: "No data for this zone yet — sync while online.",
    customZone: "My zone",
    addZoneTitle: "Add your zone",
    addZoneHint: "Click the map to drop the pin, name your zone, then save.",
    zoneNamePh: "Zone name",
    saveZone: "Save",
    loginToAdd: "Log in to save your own zones, connect your probes and receive email alerts.",
    zoneSaved: "Zone saved",
    zoneDeleted: "Zone deleted",
    saveFailed: "Save failed",
    deleteZone: "Delete",
    alertsOn: "Email alerts on",
    alertsOff: "Email alerts off",
    sensorConnect: "Connect a probe",
    sensorKeyOnce: "API key — copy it now, it won't be shown again.",
    sensorLive: "Real probe",
    sensorOffline: "Probe offline",
    sensorCurl: "Example push from your gateway",
    thresholdsTitle: "Custom thresholds",
    idealRange: "ideal range",
    sunMin: "min (h)",
    thresholdsSaved: "Thresholds saved",
    sensorHistory: "Probe history",
    noSensorData: "No probe readings yet.",
    fieldMode: "Field mode",
    freshToday: "Fresh — today",
    freshCache: "Cache from",
    tour: {
      replay: "Tutorial",
      next: "Next",
      skip: "Skip",
      done: "Done",
      steps: [
        { t: "Welcome to the Oracle", b: "60 seconds to master your pond monitoring. Let's go!" },
        { t: "Connection status", b: "Green = online, amber = offline with cached data. The Oracle works even without a network." },
        { t: "Sync", b: "One click downloads the next 7 days of weather for all your zones." },
        { t: "Field mode", b: "Big buttons, stronger contrast: readable in bright sunlight right at the ponds." },
        { t: "Your own zone", b: "Click the map, name your zone: it gets monitored like the others (login required)." },
        { t: "The verdict at a glance", b: "Validated, Partial or Rejected: today's weather check, using your real probes when connected." },
        { t: "Install the app", b: "Add the Oracle to your phone: it opens like an app, even offline." },
        { t: "That's it!", b: "Replay this tour anytime with the Tutorial button at the top." },
      ],
    },
  },
  landing: {
    overline: "Declassified dossier",
    title: "Local live feed for juvenile shrimp from your region.",
    sub: "A complete microalgae production system connecting artisanal producers with shrimp hatcheries: short chain, zero import dependency, income that stays local.",
    points: ["Artisanal live microalgae production", "Short producer → hatchery chain", "Income that stays in your region"],
    visitor: "Enter as visitor",
    google: "Continue with Google",
    divider: "or with your email",
    name: "Name",
    email: "Email",
    password: "Password",
    loginBtn: "Log in",
    signupBtn: "Create account",
    toSignup: "No account? Create one",
    toLogin: "Already have an account? Log in",
    err: "Invalid credentials or email already registered",
  },
  hero: {
    overline: "Born in El Salvador · global reach",
    lines: ["Local live feed", "for juvenile shrimp,", "grown in your region."],
    sub: "Dekrbat Pure licenses a complete microalgae production system that connects artisanal producers directly with shrimp hatcheries — a short supply chain that cuts reliance on imported feed inputs and turns CO₂ into sensor-verified carbon points.",
    ctaPrimary: "Request License",
    ctaSecondary: "See how it works",
    imageCaption: "Microalgae cultivation ponds",
    telemetryLabel: "Decarbonization oracle",
    telemetryLive: "live signal",
    telemetryNote: "Simulated concept feed",
    telemetryLines: [
      "sensor A-03 · dissolved CO₂ · reading verified",
      "oracle · natural absorption validated",
      "carbon point issued · batch #0182",
      "sensor B-11 · water quality · stable parameters",
      "oracle · pond telemetry synchronized",
      "carbon point issued · batch #0183",
    ],
  },
  valprop: {
    overline: "The proposition",
    title: "A short chain replaces an imported one",
    imported: {
      title: "Imported input",
      points: [
        "Travels thousands of kilometres to the hatchery",
        "Costs exposed to currencies and international logistics",
        "Limited traceability of biological origin",
        "Economic value that leaves the region",
      ],
    },
    local: {
      title: "Dekrbat Pure local network",
      points: [
        "Microalgae grown in ponds within the region",
        "Direct delivery from artisanal producer to hatchery",
        "Sensor telemetry in every pond",
        "Sustainable jobs and value that stays in your region",
      ],
    },
  },
  bento: {
    overline: "The system",
    title: "Four pieces, one ecosystem",
    items: {
      ponds: { title: "Cultivation ponds", desc: "Microalgae production infrastructure designed for coastal and rural conditions." },
      coops: { title: "Cooperative network", desc: "Organized artisanal producers supply hatcheries in their own region directly." },
      sensors: { title: "In-line sensors", desc: "Continuous monitoring of water quality and dissolved CO₂ in every cultivation pond." },
      oracle: { title: "Carbon oracle", desc: "Validated telemetry becomes real-time carbon points, traceable by batch." },
    },
  },
  marquee: [
    "Food sovereignty", "Zero import dependence", "Sensor traceability",
    "Sustainable local jobs", "Real-time carbon points", "Short supply chain",
  ],
  calc: {
    overline: "Concept model",
    title: "Size your pond network",
    desc: "Explore how the system's telemetry scales with cultivation surface.",
    sliderLabel: "Hectares of cultivation ponds",
    unit: "ha",
    outputs: { volume: "Relative production index", datapoints: "Sensor readings per day", points: "Carbon points issued per day" },
    disclaimer: "Simulated figures for illustration only. They do not represent real performance data.",
  },
    xr: {
      overline: "Spatial mode",
      title: "Your farm as a hologram, all around you",
      sub: "XREAL glasses, Beam Pro or a plain screen: the PSEQ2 simulator becomes a spatial 3D mockup — satellite globe, volumetric ponds, live weather.",
    },
  ctaSection: {
    title: "Ready to grow the future of shrimp?",
    desc: "Join the first licensed microalgae network for larviculture.",
    btn: "Request License",
  },
  how: {
    hero: {
      overline: "How it works",
      title: "From pond to larva, no middlemen",
      sub: "A four-step ecosystem that turns water, light and CO₂ into local live feed — measured at every stage.",
    },
    steps: [
      { k: "Step 01", title: "Construction & inoculation", desc: "Each licensed site installs its cultivation ponds and receives the starter strains together with the Dekrbat Pure production protocol." },
      { k: "Step 02", title: "Sensor-monitored growth", desc: "Optical and dissolved-CO₂ probes record water quality and biological activity in real time, pond by pond." },
      { k: "Step 03", title: "Direct local distribution", desc: "The harvest travels from the artisanal producer to the hatchery in the same region — a short chain, with no imports." },
      { k: "Step 04", title: "Oracle validation", desc: "The decarbonization oracle validates the sensor-measured natural CO₂ absorption and issues traceable carbon points." },
    ],
    sensor: {
      overline: "Technology",
      title: "Telemetry that never sleeps",
      desc: "Every licensed pond carries a sensor kit that streams continuous readings to the decarbonization oracle.",
      points: ["Optical water-quality probes", "Dissolved CO₂ sensors", "Real-time data transmission", "Traceability by pond and by batch"],
    },
    galleryCaptions: ["Shrimp larvae inspection", "Culture sample in the lab"],
  },
  licensing: {
    hero: {
      overline: "Licensing",
      title: "A license for every scale of production",
      sub: "Dekrbat Pure licenses its complete microalgae production system to cooperatives and individual sites anywhere in the world.",
    },
    coop: {
      badge: "Cooperatives",
      title: "Cooperative License",
      desc: "Regional model for cooperatives and producer associations operating multiple farms or hatcheries.",
      features: [
        "Multi-farm coverage under a single license",
        "Sensor kits allocated per pond",
        "Production protocols and team training",
        "Cooperative access to the oracle telemetry panel",
        "Connection with hatcheries in the region",
      ],
    },
    site: {
      badge: "Individual sites",
      title: "Site License",
      desc: "Tailored deployment for a single facility: hatchery, farm or pilot pond.",
      features: [
        "License dedicated to one facility",
        "Sensor kit sized for the site",
        "Assisted commissioning and initial inoculation",
        "The site's own telemetry and carbon points",
        "Growth path towards the cooperative model",
      ],
    },
    selectBtn: "Request this license",
    form: {
      title: "License request",
      desc: "Tell us about your operation and the Dekrbat Pure team will review your request.",
      name: "Full name", org: "Cooperative or company", email: "Email", phone: "Phone",
      department: "Country / Region", type: "License type", typeCoop: "Cooperative", typeSite: "Site",
      ponds: "Number of ponds or hectares", message: "Message (optional)",
      submit: "Send request", sending: "Sending…",
      success: "Request received. The Dekrbat Pure team will review it shortly.",
      error: "Could not send. Please try again.",
      selectPlaceholder: "Select an option",
    },
  },
  impact: {
    hero: {
      overline: "Impact & CO₂",
      title: "Every pond measures what it absorbs",
      sub: "Microalgae capture CO₂ naturally as they grow. Dekrbat Pure measures that absorption with sensors and validates it with its decarbonization oracle, generating real-time carbon points.",
    },
    oracle: {
      overline: "The oracle",
      title: "From sensor signal to carbon point",
      desc: "Dekrbat Pure's measurement architecture turns biological telemetry into a verifiable record, without relying on external claims.",
      flow: ["Microalgae ponds", "CO₂ sensors", "Decarbonization oracle", "Carbon points"],
      flowDescs: [
        "Natural CO₂ absorption during growth",
        "Continuous dissolved-CO₂ readings",
        "Real-time telemetry validation",
        "Record traceable by pond and batch",
      ],
    },
    telemetry: { title: "Live telemetry", note: "Concept simulation of the data flow" },
    reel: {
      overline: "Carbon story",
      title: "From pond to carbon point, in motion",
      slides: [
        { k: "01 · Ponds", title: "Living culture", desc: "Microalgae ponds capture CO₂ naturally while producing live feed for hatcheries." },
        { k: "02 · Sensors", title: "Continuous measurement", desc: "Dissolved-CO₂ and water-quality probes record every pond in real time." },
        { k: "03 · Oracle", title: "Validation", desc: "The decarbonization oracle validates the telemetry into a verifiable record." },
        { k: "04 · Points", title: "Carbon points", desc: "Each validation issues carbon points traceable by pond and by batch." },
      ],
    },
    chain: {
      overline: "Value chain",
      title: "Impact in four dimensions",
      items: [
        { title: "Environmental", desc: "Natural CO₂ extraction measured by sensors and validated by the oracle, batch by batch." },
        { title: "Social", desc: "Long-term sustainable employment for artisanal producers and local cooperatives." },
        { title: "Economic", desc: "Resilience for hatcheries by reducing exposure to imported feed inputs." },
        { title: "Supply security", desc: "A new local value chain centered on microalgae cultivation ponds." },
      ],
    },
  },
  contact: {
    hero: {
      overline: "Contact",
      title: "Let's talk about your project",
      sub: "Write to us and the Dekrbat Pure team will get back to you. You can also review the requests stored in the system.",
    },
    form: {
      name: "Full name", email: "Email", subject: "Subject", message: "Message",
      submit: "Send message", sending: "Sending…",
      success: "Message sent and stored.", error: "Could not send. Please try again.",
    },
    drawer: {
      btn: "View stored requests", title: "Stored requests", empty: "No requests stored yet.",
      licenseTag: "License", contactTag: "Contact", close: "Close", loading: "Loading…",
    },
  },
  intro: {
    dossier: "Dossier · Global", skip: "Click to skip",
    soundOn: "Sound on — click to mute", soundOff: "Sound muted",
  },
  story: {
    overline: "The story",
    title: "A solidarity economy born from water",
    scenes: [
      { k: "Scene 01", title: "Value that leaves", desc: "For years, hatchery feed arrived imported: every purchase sent resources out of the region." },
      { k: "Scene 02", title: "The producer grows", desc: "Artisanal producers raise microalgae ponds: water, sun and CO₂ become live feed." },
      { k: "Scene 03", title: "The cooperative connects", desc: "The harvest travels straight to the region's hatchery. No middlemen, no imports: a short chain." },
      { k: "Scene 04", title: "Value that stays", desc: "Sustainable local jobs, income for the cooperative and sensor-verified carbon points: the economy grows at home." },
    ],
  },
  pseq2: {
    overline: "Pre-installation visualization",
    title: "PSEQ2 — Second-Generation Sequestration Point",
    sub: "Before installing your microalgae ponds, visualize the decarbonization potential of any point on the planet: real local weather feeds the simulation and every result appears inside a holographic cube.",
    config: {
      title: "Configure your project",
      bassins: "Number of ponds",
      bassinsFree: "Or type the exact number",
      surfaceFixed: "Surface per pond: 100 m² — split into 4 independent 25 m² units to contain cross-contamination",
      totalSurface: "Total surface",
      sun: "Site coverage",
      sunFull: "Open", sunMid: "Mixed", sunLow: "Shaded",
      searchPlaceholder: "Search a city or place…",
      share: "Share simulation",
      shareCopied: "Link copied to clipboard",
    },
    location: {
      title: "Project location",
      hint: "Click the map or search a place",
      loading: "Loading local weather…",
      error: "Weather unavailable at this point",
      none: "Pick a point on the map",
      satellite: "Satellite",
      mapLabel: "Map",
      locate: "My location",
    },
    tour: {
      replay: "Tutorial",
      next: "Next",
      skip: "Skip",
      done: "Done",
      steps: [
        { t: "Welcome to the PSEQ2 simulator", b: "One minute to estimate your local live-feed production. Let's go!" },
        { t: "Number of ponds", b: "Drag the slider: each pond is an independent 100 m² unit that limits cross-contamination." },
        { t: "Solar regime", b: "Open sky, mixed or shaded: sunlight drives microalgae growth." },
        { t: "Project location", b: "Click the map or use My location: the simulator loads the real local weather." },
        { t: "The holographic cube", b: "Your results in 3D: PSEQ2 points, captured CO₂, local feed and jobs. Drag to rotate it." },
        { t: "PDF report", b: "Export a complete report of your scenario, ready to share with your cooperative." },
        { t: "Share the simulation", b: "One click copies a link with a satellite preview card for WhatsApp and social networks." },
        { t: "All set!", b: "Replay this tour anytime with the Tutorial button." },
      ],
    },
    weather: { temp: "Temperature", humidity: "Humidity", pressure: "Pressure", sunshine: "Sun per day", hours: "h" },
    rating: {
      title: "Installation verdict",
      basis: "Computed from real local weather: temperature, sun, humidity and pressure",
      levels: ["Not recommended", "Passable", "Fair", "Good", "Super"],
    },
    cubes: {
      pseq2: { label: "Potential PSEQ2", unit: "pts / year" },
      co2: { label: "Sequestered CO₂", unit: "t / year" },
      feed: { label: "Local live feed", unit: "index" },
      jobs: { label: "Local jobs", unit: "roles" },
    },
    preview: {
      title: "Report preview",
      config: "Configuration",
      weather: "Local weather",
      capacity: "Capacity summary",
      contaminationTitle: "Contamination containment",
      contaminationText: "Each 100 m² pond is split into 4 independent 25 m² units: if an outbreak appears, only that unit is isolated and quarantined — the rest of production keeps running.",
    },
    history: {
      title: "Scenario history",
      save: "Save scenario",
      saved: "Scenario saved",
      error: "Could not save the scenario",
      empty: "No saved scenarios yet: configure and save your first simulation.",
      exportPdf: "Export PDF",
      publish: "Publish",
      unpublish: "Unpublish",
      sharedTag: "Public",
      tabAll: "All",
      tabPublic: "Public",
      date: "Date",
    },
    disclaimer: "Conceptual preview model: values simulated from real local weather — neither a measurement nor a performance commitment.",
    what: {
      overline: "Definition",
      title: "What is a PSEQ2?",
      desc: "The PSEQ2 — Second-Generation Sequestration Point — is the unit Dekrbat Pure's decarbonization oracle issues when sensor telemetry validates natural CO₂ capture by the microalgae.",
      cards: [
        { title: "Measured", desc: "Dissolved-CO₂ and water-quality probes running continuously in every pond." },
        { title: "Validated", desc: "The oracle verifies telemetry in real time, pond by pond, batch by batch." },
        { title: "Issued", desc: "Each validation generates a traceable PSEQ2, visible in your holographic cubes." },
      ],
    },
    cta: {
      title: "Move from simulation to a real pond",
      desc: "Request your license and turn these holographic cubes into live telemetry.",
      btn: "Request License",
    },
    teaser: {
      overline: "New",
      title: "Visualize before you build",
      desc: "The PSEQ2 simulator projects your future ponds' decarbonization potential into 3D holographic cubes, powered by real local weather.",
      btn: "Open the simulator",
    },
    report: {
      btn: "Download PDF report",
      title: "PSEQ2 Simulation Report",
      config: "Configuration",
      capacity: "Capacity summary",
      weatherT: "Local weather",
      ratingT: "Verdict",
      bassins: "Number of ponds",
      surfaceFixed: "Surface per pond: 100 m2 (4 independent 25 m2 units, limited cross-contamination risk)",
      totalSurface: "Total surface (m2)",
      contaminationTitle: "Contamination containment",
      contaminationText: "Each 100 m2 pond is split into 4 independent 25 m2 units: if an outbreak appears, only that unit is isolated and quarantined; the rest of production keeps running.",
      sun: "Site coverage",
      locationT: "Location",
      date: "Generated on",
      footer: "Dekrbat Pure · Conceptual preview model — simulated values, no performance commitment.",
    },
  },
  footer: {
    tagline: "Local microalgae cultivation systems for shrimp larviculture, from El Salvador to the world.",
    nav: "Navigation",
    location: "El Salvador, Central America",
    rights: "All rights reserved.",
  },
};

const pt = {
  nav: {
    home: "Início", how: "Como Funciona", licensing: "Licenciamento", impact: "Impacto e CO₂",
    contact: "Contato", cta: "Solicitar Licença", pseq2: "PSEQ2", menu: "Menu", close: "Fechar", logout: "Sair", oracle: "Oráculo",
  },
  admin: {
    title: "Painel de administração",
    licenses: "Solicitações de licença",
    contacts: "Mensagens de contato",
    empty: "Nada por aqui ainda.",
    forbidden: "Acesso restrito à equipe Dekrbat Pure.",
    statusT: "Estado",
    pending: "Pendente",
    accepted: "Aceita",
    rejected: "Recusada",
    accept: "Aceitar",
    reject: "Recusar",
    loginFirst: "Entre com uma conta de administrador.",
    filterAll: "Todas",
    reply: "Responder",
    date: "Data",
  },
  oracle: {
    overline: "Oráculo offline",
    title: "Oráculo Dekrbat — previsão e constatação em tempo real",
    sub: "Instale o app: o clima de cada zona é baixado em segundo plano. Gráficos, constatações e relatórios PDF funcionam offline.",
    install: "Instalar o app",
    installing: "Use o menu do navegador para instalar",
    online: "Online",
    offline: "Offline — dados em cache",
    syncing: "Sincronizando zonas",
    syncNow: "Sincronizar agora",
    lastSync: "Última sincronização",
    never: "nunca",
    defaultZone: "Zona camaroneira",
    scenarioZone: "Seu cenário",
    constatTitle: "Constatação ao vivo",
    cachedAt: "Dados de",
    verdicts: { validated: "Validado", partial: "Parcial", rejected: "Rejeitado" },
    criteria: { temp: "Temperatura", sunshine: "Sol", humidity: "Umidade", pressure: "Pressão", co2: "CO₂" },
    predTitle: "Previsão de 7 dias",
    weeklyPts: "PSEQ2 est. por tanque / semana",
    chartTemp: "Temp máx",
    chartSun: "Sol",
    reportBtn: "Relatório PDF da zona",
    noData: "Sem dados desta zona ainda — sincronize online.",
    customZone: "Minha zona",
    addZoneTitle: "Adicione sua zona",
    addZoneHint: "Clique no mapa para colocar o marcador, nomeie sua zona e salve.",
    zoneNamePh: "Nome da zona",
    saveZone: "Salvar",
    loginToAdd: "Entre para salvar suas próprias zonas, conectar suas sondas e receber alertas por e-mail.",
    zoneSaved: "Zona salva",
    zoneDeleted: "Zona eliminada",
    saveFailed: "Erro ao salvar",
    deleteZone: "Eliminar",
    alertsOn: "Alertas por e-mail ativados",
    alertsOff: "Alertas por e-mail desativados",
    sensorConnect: "Conectar uma sonda",
    sensorKeyOnce: "Chave API — copie agora, não será mostrada novamente.",
    sensorLive: "Sonda real",
    sensorOffline: "Sonda offline",
    sensorCurl: "Exemplo de envio do seu gateway",
    thresholdsTitle: "Limiares personalizados",
    idealRange: "faixa ideal",
    sunMin: "mín (h)",
    thresholdsSaved: "Limiares salvos",
    sensorHistory: "Histórico da sonda",
    noSensorData: "Sem leituras da sonda por enquanto.",
    fieldMode: "Modo campo",
    freshToday: "Dados de hoje",
    freshCache: "Cache de",
    tour: {
      replay: "Tutorial",
      next: "Avançar",
      skip: "Pular",
      done: "Concluir",
      steps: [
        { t: "Bem-vindo ao Oracle", b: "60 segundos para dominar o monitoramento dos seus tanques. Vamos!" },
        { t: "Estado da conexão", b: "Verde = online, âmbar = offline com dados em cache. O Oracle funciona mesmo sem rede." },
        { t: "Sincronização", b: "Um clique baixa o clima dos próximos 7 dias para todas as suas zonas." },
        { t: "Modo campo", b: "Botões grandes, contraste reforçado: legível sob sol forte à beira dos tanques." },
        { t: "Sua própria zona", b: "Clique no mapa e nomeie sua zona: ela será monitorada como as outras (login necessário)." },
        { t: "O veredito num relance", b: "Validado, Parcial ou Rejeitado: o boletim do dia, com suas sondas reais quando conectadas." },
        { t: "Instale o app", b: "Adicione o Oracle ao seu telefone: abre como um aplicativo, mesmo offline." },
        { t: "É isso!", b: "Refaça este tutorial quando quiser com o botão Tutorial no topo." },
      ],
    },
  },
  landing: {
    overline: "Dossiê desclassificado",
    title: "Ração viva local para camarões juvenis da sua região.",
    sub: "Um sistema completo de produção de microalgas que conecta produtores artesanais a larvicultores de camarão: cadeia curta, zero dependência de importações, renda que fica na região.",
    points: ["Produção artesanal de microalgas vivas", "Cadeia curta produtor → larvicultor", "Renda que fica na sua região"],
    visitor: "Entrar como visitante",
    google: "Continuar com Google",
    divider: "ou com seu e-mail",
    name: "Nome",
    email: "E-mail",
    password: "Senha",
    loginBtn: "Entrar",
    signupBtn: "Criar conta",
    toSignup: "Sem conta? Crie uma",
    toLogin: "Já tem conta? Entrar",
    err: "Credenciais inválidas ou e-mail já registrado",
  },
  hero: {
    overline: "Origem El Salvador · alcance global",
    lines: ["Ração viva local", "para camarões juvenis", "da sua região."],
    sub: "A Dekrbat Pure licencia um sistema completo de produção de microalgas que conecta produtores artesanais diretamente a larvicultores de camarão — uma cadeia curta que reduz a dependência de insumos importados e transforma CO₂ em pontos de carbono verificados por sensores.",
    ctaPrimary: "Solicitar Licença",
    ctaSecondary: "Ver como funciona",
    imageCaption: "Tanques de cultivo de microalgas",
    telemetryLabel: "Oráculo de descarbonização",
    telemetryLive: "sinal ao vivo",
    telemetryNote: "Transmissão conceitual simulada",
    telemetryLines: [
      "sensor A-03 · CO₂ dissolvido · leitura verificada",
      "oráculo · absorção natural validada",
      "ponto de carbono emitido · lote #0182",
      "sensor B-11 · qualidade da água · parâmetros estáveis",
      "oráculo · telemetria por tanque sincronizada",
      "ponto de carbono emitido · lote #0183",
    ],
  },
  valprop: {
    overline: "A proposta",
    title: "Uma cadeia curta substitui uma cadeia importada",
    imported: {
      title: "Insumo importado",
      points: [
        "Viaja milhares de quilômetros até a larvicultura",
        "Custos expostos a câmbio e logística internacional",
        "Rastreabilidade limitada da origem biológica",
        "Valor econômico que sai da região",
      ],
    },
    local: {
      title: "Rede local Dekrbat Pure",
      points: [
        "Cultivo em tanques de microalgas na própria região",
        "Entrega direta do produtor artesanal ao larvicultor",
        "Telemetria de sensores em cada tanque",
        "Emprego sustentável e valor que permanece na sua região",
      ],
    },
  },
  bento: {
    overline: "O sistema",
    title: "Quatro peças, um só ecossistema",
    items: {
      ponds: { title: "Tanques de cultivo", desc: "Infraestrutura de produção de microalgas pensada para condições costeiras e rurais." },
      coops: { title: "Rede de cooperativas", desc: "Produtores artesanais organizados abastecem diretamente os laboratórios de larvas da sua região." },
      sensors: { title: "Sensores em linha", desc: "Monitoramento contínuo da qualidade da água e do CO₂ dissolvido em cada tanque." },
      oracle: { title: "Oráculo de carbono", desc: "A telemetria validada converte-se em pontos de carbono em tempo real, rastreáveis por lote." },
    },
  },
  marquee: [
    "Soberania alimentar", "Zero dependência de importações", "Rastreabilidade por sensores",
    "Emprego local sustentável", "Pontos de carbono em tempo real", "Cadeia de suprimento curta",
  ],
  calc: {
    overline: "Modelo conceitual",
    title: "Dimensione sua rede de tanques",
    desc: "Explore como a telemetria do sistema escala com a superfície de cultivo.",
    sliderLabel: "Hectares de tanques de cultivo",
    unit: "ha",
    outputs: { volume: "Índice de produção relativo", datapoints: "Leituras de sensores por dia", points: "Pontos de carbono emitidos por dia" },
    disclaimer: "Valores simulados apenas ilustrativos. Não representam dados reais de desempenho.",
  },
    xr: {
      overline: "Modo espacial",
      title: "Sua fazenda em holograma, ao seu redor",
      sub: "Óculos XREAL, Beam Pro ou uma simples tela: o simulador PSEQ2 vira uma maquete 3D espacial — globo satélite, tanques em volume, clima real.",
    },
  ctaSection: {
    title: "Pronto para cultivar o futuro do camarão?",
    desc: "Junte-se à primeira rede licenciada de microalgas para larvicultura.",
    btn: "Solicitar Licença",
  },
  how: {
    hero: {
      overline: "Como funciona",
      title: "Do tanque à larva, sem intermediários",
      sub: "Um ecossistema de quatro etapas que transforma água, luz e CO₂ em ração viva local — medida em cada fase.",
    },
    steps: [
      { k: "Etapa 01", title: "Construção e inoculação", desc: "Cada local licenciado instala seus tanques de cultivo e recebe as cepas iniciais junto com o protocolo de produção Dekrbat Pure." },
      { k: "Etapa 02", title: "Crescimento monitorado por sensores", desc: "Sondas ópticas e de CO₂ dissolvido registram a qualidade da água e a atividade biológica em tempo real, tanque por tanque." },
      { k: "Etapa 03", title: "Distribuição local direta", desc: "A colheita vai do produtor artesanal ao larvicultor da mesma região — uma cadeia curta, sem importações." },
      { k: "Etapa 04", title: "Validação do oráculo", desc: "O oráculo de descarbonização valida a absorção natural de CO₂ medida por sensores e emite pontos de carbono rastreáveis." },
    ],
    sensor: {
      overline: "Tecnologia",
      title: "Telemetria que nunca dorme",
      desc: "Cada tanque licenciado carrega um kit de sensores que transmite leituras contínuas ao oráculo de descarbonização.",
      points: ["Sondas ópticas de qualidade da água", "Sensores de CO₂ dissolvido", "Transmissão de dados em tempo real", "Rastreabilidade por tanque e por lote"],
    },
    galleryCaptions: ["Inspeção de larvas de camarão", "Amostra de cultivo em laboratório"],
  },
  licensing: {
    hero: {
      overline: "Licenciamento",
      title: "Uma licença para cada escala de produção",
      sub: "A Dekrbat Pure licencia seu sistema completo de produção de microalgas para cooperativas e locais individuais em qualquer região do mundo.",
    },
    coop: {
      badge: "Cooperativas",
      title: "Licença por Cooperativa",
      desc: "Modelo regional para cooperativas e associações de produtores com várias fazendas ou laboratórios de larvas.",
      features: [
        "Cobertura multifazendas sob uma única licença",
        "Kits de sensores alocados por tanque",
        "Protocolos de produção e treinamento da equipe",
        "Acesso da cooperativa ao painel de telemetria do oráculo",
        "Conexão com larvicultores da região",
      ],
    },
    site: {
      badge: "Locais individuais",
      title: "Licença por Local",
      desc: "Implantação sob medida para uma única instalação: laboratório de larvas, fazenda ou tanque piloto.",
      features: [
        "Licença dedicada a uma instalação",
        "Kit de sensores dimensionado para o local",
        "Comissionamento assistido e inoculação inicial",
        "Telemetria e pontos de carbono do próprio local",
        "Caminho de crescimento para o modelo cooperativo",
      ],
    },
    selectBtn: "Solicitar esta licença",
    form: {
      title: "Solicitação de licença",
      desc: "Conte-nos sobre sua operação e a equipe Dekrbat Pure avaliará seu pedido.",
      name: "Nome completo", org: "Cooperativa ou empresa", email: "E-mail", phone: "Telefone",
      department: "País / Região", type: "Tipo de licença", typeCoop: "Por cooperativa", typeSite: "Por local",
      ponds: "Número de tanques ou hectares", message: "Mensagem (opcional)",
      submit: "Enviar solicitação", sending: "Enviando…",
      success: "Pedido recebido. A equipe Dekrbat Pure irá analisá-lo em breve.",
      error: "Não foi possível enviar. Tente novamente.",
      selectPlaceholder: "Selecione uma opção",
    },
  },
  impact: {
    hero: {
      overline: "Impacto e CO₂",
      title: "Cada tanque mede o que absorve",
      sub: "As microalgas capturam CO₂ naturalmente ao crescer. A Dekrbat Pure mede essa absorção com sensores e a valida com seu oráculo de descarbonização, gerando pontos de carbono em tempo real.",
    },
    oracle: {
      overline: "O oráculo",
      title: "Do sinal do sensor ao ponto de carbono",
      desc: "A arquitetura de medição da Dekrbat Pure transforma telemetria biológica em um registro verificável, sem depender de declarações externas.",
      flow: ["Tanques de microalgas", "Sensores de CO₂", "Oráculo de descarbonização", "Pontos de carbono"],
      flowDescs: [
        "Absorção natural de CO₂ durante o crescimento",
        "Leituras contínuas de CO₂ dissolvido",
        "Validação da telemetria em tempo real",
        "Registro rastreável por tanque e lote",
      ],
    },
    telemetry: { title: "Telemetria ao vivo", note: "Simulação conceitual do fluxo de dados" },
    reel: {
      overline: "História do carbono",
      title: "Do tanque ao ponto de carbono, em movimento",
      slides: [
        { k: "01 · Tanques", title: "Cultivo vivo", desc: "Os tanques de microalgas capturam CO₂ naturalmente enquanto produzem ração viva para a larvicultura." },
        { k: "02 · Sensores", title: "Medição contínua", desc: "Sondas de CO₂ dissolvido e de qualidade da água registram cada tanque em tempo real." },
        { k: "03 · Oráculo", title: "Validação", desc: "O oráculo de descarbonização valida a telemetria e a converte em registro verificável." },
        { k: "04 · Pontos", title: "Pontos de carbono", desc: "Cada validação emite pontos de carbono rastreáveis por tanque e por lote." },
      ],
    },
    chain: {
      overline: "Cadeia de valor",
      title: "Impacto em quatro dimensões",
      items: [
        { title: "Ambiental", desc: "Extração natural de CO₂ medida por sensores e validada pelo oráculo, lote a lote." },
        { title: "Social", desc: "Emprego sustentável de longo prazo para produtores artesanais e cooperativas locais." },
        { title: "Econômico", desc: "Resiliência para larvicultores ao reduzir a exposição a insumos importados." },
        { title: "Segurança de suprimento", desc: "Uma nova cadeia de valor local centrada em tanques de cultivo de microalgas." },
      ],
    },
  },
  contact: {
    hero: {
      overline: "Contato",
      title: "Vamos falar do seu projeto",
      sub: "Escreva-nos e a equipe Dekrbat Pure responderá. Você também pode consultar as solicitações salvas no sistema.",
    },
    form: {
      name: "Nome completo", email: "E-mail", subject: "Assunto", message: "Mensagem",
      submit: "Enviar mensagem", sending: "Enviando…",
      success: "Mensagem enviada e salva.", error: "Não foi possível enviar. Tente novamente.",
    },
    drawer: {
      btn: "Ver solicitações salvas", title: "Solicitações salvas", empty: "Ainda não há solicitações registradas.",
      licenseTag: "Licença", contactTag: "Contato", close: "Fechar", loading: "Carregando…",
    },
  },
  intro: {
    dossier: "Dossiê · Global", skip: "Clique para pular",
    soundOn: "Som ativado — clique para silenciar", soundOff: "Som silenciado",
  },
  story: {
    overline: "A história",
    title: "Uma economia solidária que nasce da água",
    scenes: [
      { k: "Cena 01", title: "O valor que sai", desc: "Durante anos, a ração para larvicultura chegou importada: cada compra enviava recursos para fora da região." },
      { k: "Cena 02", title: "O produtor cultiva", desc: "Produtores artesanais erguem tanques de microalgas: água, sol e CO₂ viram ração viva." },
      { k: "Cena 03", title: "A cooperativa conecta", desc: "A colheita vai direto ao larvicultor da região. Sem intermediários, sem importações: uma cadeia curta." },
      { k: "Cena 04", title: "O valor fica", desc: "Emprego local sustentável, renda para a cooperativa e pontos de carbono verificados por sensores: a economia cresce em casa." },
    ],
  },
  pseq2: {
    overline: "Visualização pré-implantação",
    title: "PSEQ2 — Ponto de Sequestro de 2ª geração",
    sub: "Antes de instalar seus tanques de microalgas, visualize o potencial de descarbonização de qualquer ponto do planeta: o clima local real alimenta a simulação e cada resultado aparece em um cubo holográfico.",
    config: {
      title: "Configure seu projeto",
      bassins: "Número de tanques",
      bassinsFree: "Ou digite o número exato",
      surfaceFixed: "Superfície por tanque: 100 m² — dividido em 4 unidades independentes de 25 m² para limitar a contaminação cruzada",
      totalSurface: "Superfície total",
      sun: "Cobertura do local",
      sunFull: "Aberta", sunMid: "Mista", sunLow: "Sombreada",
      searchPlaceholder: "Buscar cidade ou lugar…",
      share: "Compartilhar simulação",
      shareCopied: "Link copiado",
    },
    location: {
      title: "Localização do projeto",
      hint: "Clique no mapa ou busque um lugar",
      loading: "Carregando clima local…",
      error: "Clima indisponível neste ponto",
      none: "Escolha um ponto no mapa",
      satellite: "Satélite",
      mapLabel: "Mapa",
      locate: "Minha localização",
    },
    tour: {
      replay: "Tutorial",
      next: "Avançar",
      skip: "Pular",
      done: "Concluir",
      steps: [
        { t: "Bem-vindo ao simulador PSEQ2", b: "Um minuto para estimar sua produção local de alimento vivo. Vamos!" },
        { t: "Número de tanques", b: "Arraste o controle: cada tanque é uma unidade independente de 100 m² que limita a contaminação cruzada." },
        { t: "Regime solar", b: "Céu aberto, misto ou sombreado: a luz conduz o crescimento das microalgas." },
        { t: "Localização do projeto", b: "Clique no mapa ou use Minha localização: o simulador carrega o clima real do local." },
        { t: "O cubo holográfico", b: "Seus resultados em 3D: pontos PSEQ2, CO₂ capturado, alimento local e empregos. Gire com o dedo." },
        { t: "Relatório PDF", b: "Exporte um relatório completo do seu cenário, pronto para compartilhar com sua cooperativa." },
        { t: "Compartilhar a simulação", b: "Um clique copia um link com cartão satélite de prévia para WhatsApp e redes sociais." },
        { t: "Pronto!", b: "Refaça este tutorial quando quiser com o botão Tutorial." },
      ],
    },
    weather: { temp: "Temperatura", humidity: "Umidade", pressure: "Pressão", sunshine: "Sol por dia", hours: "h" },
    rating: {
      title: "Veredito de implantação",
      basis: "Calculado com o clima local real: temperatura, sol, umidade e pressão",
      levels: ["Não recomendado", "Razoável", "Correto", "Bom", "Super"],
    },
    cubes: {
      pseq2: { label: "PSEQ2 potenciais", unit: "pts / ano" },
      co2: { label: "CO₂ sequestrado", unit: "t / ano" },
      feed: { label: "Ração viva local", unit: "índice" },
      jobs: { label: "Empregos locais", unit: "postos" },
    },
    preview: {
      title: "Prévia do relatório",
      config: "Configuração",
      weather: "Clima local",
      capacity: "Resumo de capacidade",
      contaminationTitle: "Contenção da contaminação",
      contaminationText: "Cada tanque de 100 m² é dividido em 4 unidades independentes de 25 m²: se surgir um foco, apenas essa unidade é isolada e entra em quarentena — o restante da produção continua.",
    },
    history: {
      title: "Histórico de cenários",
      save: "Salvar cenário",
      saved: "Cenário salvo",
      error: "Não foi possível salvar o cenário",
      empty: "Nenhum cenário salvo ainda: configure e salve sua primeira simulação.",
      exportPdf: "Exportar PDF",
      publish: "Publicar",
      unpublish: "Retirar",
      sharedTag: "Público",
      tabAll: "Todos",
      tabPublic: "Públicos",
      date: "Data",
    },
    disclaimer: "Modelo conceitual de pré-visualização: valores simulados a partir do clima local real, não constituem medição nem compromisso de desempenho.",
    what: {
      overline: "Definição",
      title: "O que é um PSEQ2?",
      desc: "O PSEQ2 — Ponto de Sequestro de segunda geração — é a unidade emitida pelo oráculo de descarbonização da Dekrbat Pure quando a telemetria dos sensores valida uma captura natural de CO₂ pelas microalgas.",
      cards: [
        { title: "Medido", desc: "Sondas de CO₂ dissolvido e qualidade da água em contínuo, em cada tanque." },
        { title: "Validado", desc: "O oráculo verifica a telemetria em tempo real, tanque por tanque, lote por lote." },
        { title: "Emitido", desc: "Cada validação gera um PSEQ2 rastreável, visível nos seus cubos holográficos." },
      ],
    },
    cta: {
      title: "Passe da simulação ao tanque real",
      desc: "Solicite sua licença e transforme esses cubos holográficos em telemetria real.",
      btn: "Solicitar Licença",
    },
    teaser: {
      overline: "Novo",
      title: "Visualize antes de instalar",
      desc: "O simulador PSEQ2 projeta o potencial de descarbonização dos seus futuros tanques em cubos holográficos 3D, com o clima local real.",
      btn: "Abrir o simulador",
    },
    report: {
      btn: "Baixar relatório PDF",
      title: "Relatorio de simulacao PSEQ2",
      config: "Configuracao",
      capacity: "Resumo de capacidade",
      weatherT: "Clima local",
      ratingT: "Veredito",
      bassins: "Numero de tanques",
      surfaceFixed: "Superficie por tanque: 100 m2 (4 unidades independentes de 25 m2, risco de contaminacao cruzada limitado)",
      totalSurface: "Superficie total (m2)",
      contaminationTitle: "Contencao da contaminacao",
      contaminationText: "Cada tanque de 100 m2 e dividido em 4 unidades independentes de 25 m2: se surgir um foco, apenas essa unidade fica isolada e em quarentena; o restante da producao continua.",
      sun: "Cobertura do local",
      locationT: "Localizacao",
      date: "Gerado em",
      footer: "Dekrbat Pure · Modelo conceitual de pre-visualizacao — valores simulados, sem compromisso de desempenho.",
    },
  },
  footer: {
    tagline: "Sistemas locais de cultivo de microalgas para a larvicultura de camarão, do El Salvador para o mundo.",
    nav: "Navegação",
    location: "El Salvador, América Central",
    rights: "Todos os direitos reservados.",
  },
};

export const dictionary = { es, en, pt, fr, ...extraDictionaries };
